var data = {
  "width": 24,
  "height": 24,
  "body": "<g id=\"evaInfoFill0\"><g id=\"evaInfoFill1\"><path id=\"evaInfoFill2\" fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 14a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0Zm-1-7a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;